<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">
          {{ $t('grant_budget_management.budget_preparation') }}
        </h4>
      </template>
      <template v-slot:body>
        <b-row>

          <b-col xl="4" lg="4" md="4" sm="12" xs="12">
            <b-form-group
            class="row"
            label-cols-md="12"
            label-cols-lg="4"
              :label="$t('grant_budget_management.organization')"
              label-for="org_id"
            >
              <b-form-select
                plain
                v-model="search.org_id"
                :options="organizationList"
                id="org_id"
              >
              <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
              </template>
              </b-form-select>
            </b-form-group>
          </b-col>

         <b-col xl="4" lg="4" md="4" sm="12" xs="12">
            <b-form-group
              class="row"
              label-cols-md="12"
              label-cols-lg="4"
              :label="$t('grant_budget_management.fiscal_year')"
              label-for="fiscal_year_id"
            >
              <b-form-select
                plain
                v-model="search.fiscal_year_id"
                :options="fiscalYearList"
                id="fiscal_year_id"
              >
              <template v-slot:first>
                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
              </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="12" xs="12">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <!-- /Search Form -->

    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title"> {{ $t('grant_budget_management.budget_preparation') + ' ' + $t('globalTrans.list') }}</h4>
          </template>

          <template v-slot:headerAction>
            <b-button variant="primary" @click="addForm">
              <i class="fas fa-plus"></i>{{  $t('globalTrans.add_new') }}
            </b-button>
          </template>

          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>

                    <template v-slot:cell(status)="data">
                      <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                      <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>

                    <!-- Action -->
                    <template v-slot:cell(action)="data">
                      <!-- <b-button variant=" iq-bg-success mr-1 mb-1" size="sm" v-if="data.item.flag===0">
                        <router-link :to="{ path: '/grant-allowance-service/budget-management/budget-preparation-add', query: { id: data.item.id }}"
                          class="iq-bg-success mr-1 mb-1" size="sm">
                          <i class="ri-ball-pen-fill m-0"></i>
                        </router-link>
                      </b-button>

                     <b-button title="View Details" v-b-modal.modal-5 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>

                      <b-button  v-if="data.item.process_status !== 3" title="Change Status" :variant="data.item.status === 2 ? ' iq-bg-danger' : ' iq-bg-success'" size="sm" @click="remove(data.item)">
                        <i class="fas" :class="data.item.status === 2 ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                      </b-button> -->
                      <router-link v-if="data.item.process_status !== 3" :to="{ path: '/grant-allowance-service/budget-management/budget-preparation-add', query: { id: data.item.id }}"
                          class="btn_table_action btn_blue"><i class="ri-ball-pen-fill m-0"></i>
                      </router-link>
                      <a href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-5 @click="view(data.item)"><i class="ri-eye-fill m-0"></i></a>
                      <span v-if="data.item.process_status !==3">
                           <a href="javascript:" class="btn_table_action btn_rad" title="status" v-if="data.item.status === 2" @click="remove(data.item)"> <i class="fas fa-toggle-off"></i></a>
                          <a href="javascript:" class="btn_table_action btn_blue" title="status" v-else @click="remove(data.item)"> <i class="fas fa-toggle-on"></i></a>
                      </span>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal id="modal-5" size="xl" :title="$t('grant_budget_management.budget_preparation_details')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId"/>
    </b-modal>

  </b-container>
</template>
<script>
import Details from './Details'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { budgetPreparationListApi, budgetPreparationToggleStatusApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import moment from 'moment'

export default {
    mixins: [RouteBasedList],
    components: {
        Details
    },
    data () {
      return {
        search: {
          org_id: 0,
          fiscal_year_id: 0
        },
        item: null,
        rows: []
      }
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
                { label: this.$t('user_role.organization'), class: 'text-center' },
                { label: this.$t('grant_budget_management.fiscal_year'), class: 'text-center' },
                { label: this.$t('globalTrans.created_at_date'), class: 'text-center' },
                { label: this.$t('globalTrans.status'), class: 'text-center w-15' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                  { key: 'index' },
                  { key: 'org_bn' },
                  { key: 'fiscal_year_bn' },
                  { key: 'created_at' },
                  { key: 'action' }
                ]
            } else {
                keys = [
                  { key: 'index' },
                  { key: 'org_en' },
                  { key: 'fiscal_year_en' },
                  { key: 'created_at' },
                  { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        },
        organizationList () {
          return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        fiscalYearList: function () {
          return this.$store.state.commonObj.fiscalYearList
        }
    },
    watch: {
    },
    created () {
        this.loadData()
    },
    mounted () {
    },
    methods: {
        searchData () {
          this.loadData()
        },
        view (item) {
          this.editItemId = item.id
        },
        edit (item) {
          this.editItemId = item.id
          this.item = item
          this.$router.push({ path: '/grant-allowance-service/budget-management/budget-preparation-add', query: { item: item } })
        },
        remove (item) {
          this.changeStatus(grantAllowanceServiceBaseUrl, budgetPreparationToggleStatusApi, item)
        },
        addForm () {
          this.$router.push({ path: '/grant-allowance-service/budget-management/budget-preparation-add' })
        },
        // --- Load ---
        loadData () {
          const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
          this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
          RestApi.getData(grantAllowanceServiceBaseUrl, budgetPreparationListApi, params).then(response => {
              if (response.success) {
                  this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                  this.paginationData(response.data)
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
          })
        },
        getRelationalData (data) {
          const listData = data.map(item => {
            // Relational
            const org = this.$store.state.orgList.find(org => org.status === 0 && org.value === item.org_id)
            const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscalYear => fiscalYear.status === 0 && fiscalYear.value === item.fiscal_year_id)
            const tmpCreatedTime = moment(item.created_at).startOf('minute').fromNow()

            // Evaluate
            const evaluationData = {
              org_bn: org !== undefined ? org.text_bn : '',
              org_en: org !== undefined ? org.text_en : '',
              fiscal_year_bn: fiscalYear !== undefined ? fiscalYear.text_bn : '',
              fiscal_year_en: fiscalYear !== undefined ? fiscalYear.text_en : '',
              created_at: tmpCreatedTime !== undefined ? tmpCreatedTime : ''
            }

            // Assign
            return Object.assign({}, item, evaluationData)
          })
          return listData
        }
    }
}
</script>
